/**
 * 공개 뷰 비밀번호 팝업의 행 추가/삭제 (F272, 사장님 확정 2026-08-08).
 *
 * ★ 전부 **위임**이다 — 팝업(dox_passwords.html)은 nx.modal 이 fetch 로
 *   끼워 넣는 조각이라 그 안 <script> 는 실행되지 않는다(dox_icon 과 같은
 *   이유). 부팅 때 document 에 한 번만 건다.
 *
 * [추가] — data-nx-pw-add: <template id="nx-pw-row-tpl"> 를 복제해 붙인다.
 *   상한(data-pw-max)은 서버와 같은 값이다 — 넘으면 조용히 무시(서버가
 *   최종 방어). 새 행의 비밀번호 칸에 초점을 준다.
 * [삭제] — data-nx-pw-del: 그 행만 뗀다. 행이 다 없어지면 「없음」 문구를
 *   되살린다. 저장은 폼 제출 몫 — 빈 목록 = 비밀번호 없음.
 */

export function initDoxPw(): void {
  document.addEventListener('click', (ev: Event) => {
    const t0 = ev.target as HTMLElement | null;
    if (!t0) return;

    if (t0.closest('[data-nx-pw-add]')) {
      const rows = document.getElementById('nx-pw-rows');
      const tpl = document.getElementById('nx-pw-row-tpl') as HTMLTemplateElement | null;
      if (!rows || !tpl) return;
      const max = Number(rows.dataset.pwMax || '20');
      if (rows.querySelectorAll('[data-nx-pw-row]').length >= max) return;
      rows.appendChild(tpl.content.cloneNode(true));
      const none = document.getElementById('nx-pw-none');
      if (none) none.hidden = true;
      const last = rows.querySelector(
        '[data-nx-pw-row]:last-child input[name="pw"]',
      ) as HTMLInputElement | null;
      last?.focus();
      return;
    }

    const del = t0.closest('[data-nx-pw-del]');
    if (del) {
      del.closest('[data-nx-pw-row]')?.remove();
      const rows = document.getElementById('nx-pw-rows');
      if (rows && !rows.querySelector('[data-nx-pw-row]')) {
        const none = document.getElementById('nx-pw-none');
        if (none) none.hidden = false;
      }
    }
  }, true);
}
